// Function to check if a select has a value
function hasValue(select) {
  return select.value && select.value !== '';
}

// Generic function to show/hide fields based on select values
function toggleFields(beneficiaryContainer, fieldType) {
  const selectClass = `.${fieldType}-select`;
  const dataAttribute = `data-${fieldType}-index`;
  const selects = beneficiaryContainer.querySelectorAll(selectClass);

  // Check each field and show/hide the next one accordingly
  for (let i = 1; i < 4; i++) { // Check fields 1, 2, 3 to determine visibility of 2, 3, 4
    const currentSelect = selects[i];
    const nextField = beneficiaryContainer.querySelector(`[${dataAttribute}="${i + 1}"]`);

    if (currentSelect && nextField) {
      if (hasValue(currentSelect)) {
        nextField.style.display = 'block';
      } else {
        // Hide next field and all subsequent fields
        for (let j = i + 1; j <= 4; j++) {
          const fieldToHide = beneficiaryContainer.querySelector(`[${dataAttribute}="${j}"]`);
          if (fieldToHide) {
            fieldToHide.style.display = 'none';
            // Clear the value when hiding
            const select = fieldToHide.querySelector('select');
            if (select) select.value = '';
          }
        }
        break; // Stop checking once we find an empty field
      }
    }
  }
}

// Function to show/hide citizenship fields
function toggleCitizenshipFields(beneficiaryContainer) {
  toggleFields(beneficiaryContainer, 'citizenship');
}

// Function to show/hide taxation fields
function toggleTaxationFields(beneficiaryContainer) {
  toggleFields(beneficiaryContainer, 'taxation');
}

// Add event listeners to all beneficiary forms
function initializeBeneficiaryForms() {
  const beneficiaryContainers = document.querySelectorAll("#beneficiary-form-container");

  beneficiaryContainers.forEach(container => {
    // Add event listeners to citizenship selects
    const citizenshipSelects = container.querySelectorAll('.citizenship-select');
    citizenshipSelects.forEach(select => {
      select.addEventListener('change', function() {
        toggleCitizenshipFields(container);
      });
    });

    // Add event listeners to taxation selects
    const taxationSelects = container.querySelectorAll('.taxation-select');
    taxationSelects.forEach(select => {
      select.addEventListener('change', function() {
        toggleTaxationFields(container);
      });
    });

    // Initialize the state
    toggleCitizenshipFields(container);
    toggleTaxationFields(container);
  });
}

// Initialize on turbolinks load
document.addEventListener('turbo:load', initializeBeneficiaryForms);
